import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { History, Check } from "lucide-react";
import { toast } from "sonner";

export default function Corrections() {
  const [items, setItems] = useState([]);
  const [edits, setEdits] = useState({});

  const load = () => api.get("/rides/corrections").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const setField = (id, k, v) => setEdits((e) => ({ ...e, [id]: { ...e[id], [k]: v } }));

  const validate = async (ride) => {
    const e = edits[ride.id] || {};
    try {
      await api.put(`/rides/${ride.id}/correct`, {
        pickup_time: e.pickup_time || ride.ts_prise || "",
        dropoff_time: e.dropoff_time || ride.ts_depose || "",
      });
      toast.success("Course corrigée et validée");
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <History className="h-6 w-6 text-primary" /> Rétroviseur Horodateur
        </h1>
        <p className="text-muted-foreground text-sm">Arbitrage des oublis d'horodatage signalés par les chauffeurs.</p>
      </div>

      {items.length === 0 ? (
        <Card className="p-8 rounded-md shadow-none text-center text-muted-foreground" data-testid="corrections-empty">
          Aucune course en attente de correction. 🎉
        </Card>
      ) : (
        <div className="space-y-3" data-testid="corrections-list">
          {items.map((r) => (
            <Card key={r.id} className="p-4 rounded-md shadow-none" data-testid={`correction-${r.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                <div>
                  <p className="font-semibold">{r.time} · {r.patient_name}</p>
                  <p className="text-xs text-muted-foreground">{r.pickup_address} → {r.dropoff_address} · {r.assigned_vehicle_label}</p>
                </div>
                <Badge variant="destructive">ATTENTE_CORRECTION</Badge>
              </div>
              <div className="grid grid-cols-2 gap-3 max-w-md">
                <div>
                  <Label className="text-xs">Heure prise en charge</Label>
                  <Input type="time" defaultValue={r.ts_prise || ""} onChange={(e) => setField(r.id, "pickup_time", e.target.value)} className="mt-1" data-testid={`correct-pickup-${r.id}`} />
                </div>
                <div>
                  <Label className="text-xs">Heure dépose</Label>
                  <Input type="time" defaultValue={r.ts_depose || ""} onChange={(e) => setField(r.id, "dropoff_time", e.target.value)} className="mt-1" data-testid={`correct-dropoff-${r.id}`} />
                </div>
              </div>
              <Button className="mt-3 gap-2" onClick={() => validate(r)} data-testid={`correct-validate-${r.id}`}>
                <Check className="h-4 w-4" /> Valider (CORRIGE_MANUEL)
              </Button>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
